export default class EmailAddress {
  constructor(address = "") {
    this.address = address
  }

  export() {
    return this.address;
  }
}
